// src/redux/reducers/siteReducer.js
// import { SET_UI_FEATURE } from "../actions/alerttrendAtion";

import { SET_UI_FEATURE } from "../actions/uiFeaturesAction";
const initialState = {
    uifeature: [],
};

const uiFeatureReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_UI_FEATURE:
      return {
        ...state,
        uifeature: action.payload,
      };
    default:
      return state;
  }
};

export default uiFeatureReducer;
